import { defineMessage } from 'services/localization';

export const messages = {
    postApprovalChangeDetected: defineMessage('changes_have_been_made_in_xero_after_approval'),
    updatedExternallyResetTemplate: defineMessage('this_request_has_been_u_flow_has_been_restarted'),
    emailToPartnerSentSupplier: defineMessage('templatename_has_been_sent_to_the_supplier'),
    emailToPartnerSentCustomer: defineMessage('templatename_has_been_sent_to_the_customer'),
    approvedInXero: defineMessage('request_has_been_approved_directly_in_xero'),
    rejectedExternally: defineMessage('request_has_been_rejected_by_xero'),
    cancelledInXero: defineMessage('request_has_been_cancelled_in_xero'),
    markedAsBilled: defineMessage('marked_purchase_order_as_billed'),
    markAsBilledSynced: defineMessage('billed_status_has_been_synced_to_xero'),
    markAsCustomerDecisionSynced: defineMessage('pushed_the_customers_decision_to_xero'),
    unmarkedAsBilled: defineMessage('unmarked_purchase_order_as_billed'),
    requestMatchedByUserPO: defineMessage('matched_the_bills_with__rder_on_xero_matching_v'),
    requestMatchedByUserBill: defineMessage('matched_this_bill_with__ders_on_xero_matching_v'),
    requestMatchedBySystemPO: defineMessage('automatically_matched_t_rder_on_xero_matching_v'),
    requestMatchedBySystemBill: defineMessage('automatically_matched_t_ders_on_xero_matching_v'),
    requestUnmatchedByUserPO: defineMessage('unmatched_the_bills_fro_rder_on_xero_matching_v'),
    requestUnmatchedByUserBill: defineMessage('unmatched_this_bill_fro_ders_on_xero_matching_v'),
    requestUnmatchedBySystemPO: defineMessage('automatically_unmatched_rder_on_xero_matching_v'),
    requestUnmatchedBySystemBill: defineMessage('automatically_unmatched_ders_on_xero_matching_v'),
    airwallexBatchPaymentRequestPaid: defineMessage('sent_the_request_to_payment'),
    changesMatchedDocument: defineMessage('name_amount'),
    changesUnmatchedDocument: defineMessage('name_amount'),
    stepChangeAddedApproverPOMatching: defineMessage('added_approver_as_an_ap_here_they_are_requester'),
};
